import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import 'dayjs/locale/lv'
import 'dayjs/locale/ru'
import 'dayjs/locale/en'

const locale = window.location.pathname.slice(1, 3) ?? 'lv'
dayjs.locale(['lv', 'ru', 'en'].includes(locale) ? locale : 'lv')
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)

/**
 * @return {String} - DD.MM.YYYY
 */
export function formatDate(date: Date | string): string {
    return dayjs(date).format('DD.MM.YYYY')
}

/**
 * @param {Date | String} date
 * @return {String} - 23. aug.
 */
export function readableDateAndShortMonth(date: Date | string): string {
    const localDate = utcToLocal(date)

    if (localDate.format('MMMM')?.length > 5) {
        return localDate.format(dayjs.locale() === 'en' ? 'Do MMM.' : ('DD. MMM' + (dayjs.locale() === 'lv' ? '.' : '')))

    } else {
        return localDate.format(dayjs.locale() === 'en' ? 'Do MMMM' : 'DD. MMMM')
    }
}

/**
 * @param {Date | String} date
 * @return {String} - YYYY-MM-DD
 */
export function formatDateToMySqlFormat(date: Date | string): string {
    return dayjs(date).format('YYYY-MM-DD')
}


/**
 * @param {String} dateString - DD.MM.YYYY
 * @return {Date | NULL}
 */
export function parseDate(date: string): Date | null {
    const dateObject = dayjs(date, 'DD.MM.YYYY')

    if (dateObject.isValid()) {
        return dateObject.toDate()
    }

    return null
}

export function utcToLocal(date: Date | string): dayjs.Dayjs {
    return dayjs.tz(date, 'UTC').tz('Europe/Riga')
}

export { dayjs }
